<template>
  <div class="mit-spaces-map-edit">
    <BaseMitLoading class="mit-progress" :show="loading" :overlayFullscreen="false"/>
    <v-dialog v-model="saveDialog" width="400">
        <v-card>
            <v-card-title v-if="saveResults.success" class="text-h5 primary lighten-2">
             Saved
            </v-card-title>
            <v-card-title v-else class="text-h5 red lighten-2">
             Error
            </v-card-title>

          <v-card-text class="pt-5">
              <div v-if="saveResults.success">
                  Successfully saved {{saveResults.successNum}} item(s)
              </div>
              <div v-else>
                  Failed to save {{saveResults.failedNum}} item(s)
              </div>
              <div v-if="saveResults.failedMessage">{{saveResults.failedMessage}}</div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="closeSaveDialog">Close</v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
    <v-card flat>
        <v-row class="pa-0">
             <v-col cols="12" class="pa-0">
            <v-toolbar class="fixed-bar" style="width:100%;" color="grey lighten-1" elevation="2" rounded floating >
                <v-autocomplete class="pt-6" :clearable="true" dense solo :filter="autocompleteSearch" v-model="search" :items="spacesList" label="Search" item-text="mitIdShort" return-object @change="autocompleteChanged">
                   <template v-slot:item="data">
                     <template v-if="typeof data.spaceType === 'floor'">
                       <v-list-item-content v-text="'Floor '+data.level"></v-list-item-content>
                     </template>
                     <template v-else>
                       <v-list-item-avatar>
                         <v-icon>mdi-office-building-outline</v-icon>
                       </v-list-item-avatar>
                       <v-list-item-content>
                           <div v-if="data.item.name.length > 0">
                                <v-list-item-title v-html="data.item.name"></v-list-item-title>
                                <v-list-item-title v-html="data.item.mitIdShort"></v-list-item-title>
                                <v-list-item-subtitle v-html="data.item.useType"></v-list-item-subtitle>
                           </div>
                           <div v-else>
                               <v-list-item-title v-html="data.item.mitIdShort"></v-list-item-title>
                               <v-list-item-subtitle v-html="data.item.useType"></v-list-item-subtitle>
                           </div>
                       </v-list-item-content>
                     </template>
                   </template>
               </v-autocomplete>
               <!-- <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details @change="drawMap()"></v-text-field> -->
               <v-autocomplete dense solo dense :clearable="true" class="pl-3 pt-6" label="Types" v-model="selectedType" :items="info.spaceTypes"  @change="drawMap()"></v-autocomplete>
               <v-autocomplete dense solo :clearable="true" class="pl-3 pt-6" label="Organizations" v-model="selectedOrg" :items="info.orgs" @change="drawMap()"></v-autocomplete>
               <v-select solo dense class="pl-3 pt-6 pr-10" label="Floor" :items="floors" item-text="name" item-value="val" v-model="selectedFloor" @change="changeFloor()"></v-select>
               <v-spacer></v-spacer>
               <v-btn dark id="zoom_in" class="mx-2" fab small color="">
                   <!-- <v-icon dark>mdi-plus</v-icon> -->
                   <v-icon dark>mdi-magnify-plus-outline</v-icon>
               </v-btn>
               <v-btn dark id="zoom_out" class="mx-2" fab small color="">
                   <!-- <v-icon dark>mdi-minus</v-icon> -->
                   <v-icon dark>mdi-magnify-minus-outline</v-icon>
               </v-btn>
               <v-btn dark id="zoom_reset" class="mx-2" fab small color="">
                   <!-- Reset Zoom -->
                   <v-icon dark>mdi-restart</v-icon>
               </v-btn>
            </v-toolbar>
            </v-col>
        </v-row>
       <v-row>
           <v-col cols="12">
               <!-- MAP INSERTION HERE by the service. We pass this SVG id as a reference for it to hook into -->
               <div class="scrollable pa-0">
                   <svg id="mit-svg" ></svg>
               </div>
               <div class="toolbar-drawing-left" v-if="editMode">
                    <v-btn v-if="!drawing" dark class="mx-2" fab color="primary" @click="startDrawing()">
                       <v-icon>mdi-pencil-outline</v-icon>
                    </v-btn>
                    <v-card v-else>
                       <v-card-title class="text-h6 grey lighten-1 pa-2">
                           Objects
                       </v-card-title>

                       <v-card-text>
                           <v-list dense>
                               <v-list-item-group color="primary" v-model="palletObjectSelected" @change="palletObjectChanged()">
                                   <v-list-item class="mr-0 ml-0 pl-0"v-for="(obj, index) in palletObjects" :key="index" :value="obj.id">
                                       <v-list-item-icon class="mr-0 ml-0 pl-0">
                                         <v-img contain max-height="30" max-width="60" :src="obj.iconPath"></v-img>
                                       </v-list-item-icon>
                                       <v-list-item-content>
                                         <v-list-item-title>{{obj.name}}</v-list-item-title>
                                       </v-list-item-content>
                                   </v-list-item>
                               </v-list-item-group>
                          </v-list>
                       </v-card-text>
                   </v-card>
               </div>
               <div class="toolbar-drawing-center">
                   <v-card v-if="drawing">
                     <v-card-subtitle dark class="primary white--text lighten-1 pa-2">
                       Editing
                     </v-card-subtitle>
                     <v-card-text class="pa-0">
                         <v-btn text small color="" @click="save()">
                             <v-icon>mdi-content-save</v-icon>
                             Save
                         </v-btn>
                         <v-btn text small color="" @click="cancel()">
                             <v-icon>mdi-cancel</v-icon>
                             Cancel
                         </v-btn>
                     </v-card-text>
                  </v-card>
               </div>
               <div class="toolbar-drawing-right">
                   <v-card v-if="selectedSpace">
                     <v-card-title class="text-h6 grey lighten-1 pa-1 pl-2">
                         Selected {{selectedSpace.properties.name || selectedSpace.properties.mitId}}<v-spacer></v-spacer> <v-btn text class="mx-0" fab small @click="closeProperties()">
                             <!-- <v-icon dark>mdi-plus</v-icon> -->
                             <v-icon>mdi-close-circle-outline</v-icon>
                         </v-btn>
                     </v-card-title>

                     <v-divider></v-divider>

                     <v-card-text v-if="!drawing">
                         <div><b>Name:</b> {{selectedSpace.properties.name || selectedSpace.properties.mitIdShort}}</div>
                         <div><b>Description:</b><br> {{selectedSpace.properties.description}}</div>
                         <!-- <div><b>ShortId:</b> {{selectedSpace.properties.mitIdShort}}</div> -->
                         <div><b>ID:</b> {{selectedSpace.properties.mitId}}</div>
                         <div v-if="selectedSpace.properties.spaceType == 'space'">
                             <div><b>Organization:</b> {{selectedSpace.properties.org}}</div>
                             <div><b>Area (sqfoot):</b> {{selectedSpace.properties.sqfoot}}</div>
                         </div>
                         <div><b>Type:</b> {{selectedSpace.properties.useType}}</div>
                         <div v-if="selectedSpace.properties.equipment && selectedSpace.properties.equipment.length > 0"><b>Equipment:</b><br>{{selectedSpace.properties.equipment}}</div>
                         <div v-if="selectedSpace.properties.personCapacity"><b>Person Capacity:</b> {{selectedSpace.properties.personCapacity}}</div>
                         <div v-if="selectedSpace.properties.seating && selectedSpace.properties.seating.length > 0"><b>Seating:</b> {{selectedSpace.properties.seating}}</div>
                         <div v-if="selectedSpace.properties.images.length > 0"><b>Images:</b></div>
                         <v-row class="pt-5 pl-1">
                            <!-- <v-col col="auto"> -->
                                <v-img @click="dialogImages = true;" class="ma-1" v-for="(image, index) in selectedSpace.properties.images" max-width="130px" :src="'/images/'+image"></v-img>
                            <!-- </v-col> -->
                         </v-row>
                         <v-dialog v-model="dialogImages" max-width="800px">
                            <v-card elevation="24">
                                <v-toolbar dense color="grey lighten-1">
                                    <b>{{selectedSpace.properties.mitId}}</b><span class="pl-1">Images</span><v-spacer></v-spacer><v-btn color="grey lighten-1" elevation="0" fab small @click="dialogImages=false"><v-icon>mdi-close-circle-outline</v-icon></v-btn>
                                </v-toolbar>
                                <v-carousel>
                                    <v-carousel-item
                                    v-for="(item,i) in selectedSpace.properties.images"
                                    :key="i"
                                    :src="'/images/'+item"
                                    reverse-transition="fade-transition"
                                    transition="fade-transition"
                                    ></v-carousel-item>
                                </v-carousel>
                            </v-card>
                         </v-dialog>
                         <!-- <span v-for="(image, index) in selectedSpace.properties.images">
                                <v-img contain max-height="200" max-width="100" :src="'/images/'+selectedSpace.properties.images[index]"></v-img>
                         </span> -->
                     </v-card-text>

                     <div v-if="drawing">
                        <!-- drawing -->
                         <v-btn class="ma-2 mb-4" text outlined :disabled="selectedSpace.properties.spaceType !== 'object'" color="blue darken-2" @click="changeSize(1.1)">+size</v-btn>
                         <v-btn class="ma-2 mb-4" text outlined :disabled="selectedSpace.properties.spaceType !== 'object'" color="blue darken-2" @click="changeSize(.9)">-size</v-btn>
                         <v-text-field style="max-width:100px;" :disabled="selectedSpace.properties.spaceType !== 'object'" class="pa-2 pt-0" outlined dense hide-details min="-360" max="360" v-model.number="selectedSpace.properties.rotation" type="number" label="Rotation" @change="rotate"></v-text-field>
                         <v-text-field dense hide-details outlined class="pa-2" filled readonly v-model="selectedSpace.properties.mitId" label="ID"></v-text-field>
                         <v-checkbox class="pa-0 ma-0 pl-2" dense @change="editedSelectedSpaceProperties" v-model="selectedSpace.properties.commonArea" label="Color as common area"></v-checkbox>
                         <v-checkbox class="pa-0 ma-0 pl-2" dense @change="editedSelectedSpaceProperties" v-model="selectedSpace.properties.stairElevator" label="Color as Stairs or Elevator"></v-checkbox>
                         <v-divider ></v-divider>
                         <v-text-field dense hide-details outlined
                         @focus="editNameEnter"
                         @blur="editNameLeave"
                         @change="editedSelectedSpaceProperties" class="pl-2 pr-2 pt-3" v-model="selectedSpace.properties.name" label="Name"></v-text-field>
                         <v-textarea rows="3" counter maxlength="300" outlined @change="editedSelectedSpaceProperties" class="pa-2 mt-2 pb-0" v-model="selectedSpace.properties.description" label="Description"></v-textarea>
                         <v-textarea rows="3" class="pa-2 pt-3 pb-0" counter maxlength="400" outlined @change="editedSelectedSpaceProperties"  v-model="selectedSpace.properties.equipment" label="Equipment" hint="Equipment in this space, useful for reservable spaces"></v-textarea>
                         <v-text-field class="pa-2 pt-0" outlined dense hide-details min="0" max="10000" v-model.number="selectedSpace.properties.personCapacity" type="number" label="Max. Person Capacity"  @change="editedSelectedSpaceProperties" hint="Max number of people"></v-text-field>
                         <v-text-field class="pa-2 pt-0 pb-3" dense hide-details outlined @change="editedSelectedSpaceProperties" v-model="selectedSpace.properties.seating" label="Seating" hint="Seating in this space"></v-text-field>
                        <v-divider ></v-divider>
                        <v-row no-gutters>
                            <v-col cols="9">
                                <v-file-input :loading="selectedSpaceImageToUploadLoading" class="pt-3" dense v-model="selectedSpaceImageToUpload" accept="image/*" label="Primary Image" hint="320px X 320px or 320px X 640px or less in size" persistent-hint ></v-file-input>
                            </v-col>
                            <v-col cols="3">
                                <v-btn class="mt-3" :disabled="selectedSpaceImageToUpload == null" color="primary lighten-2" small @click="uploadSpaceImage(selectedSpace.properties.id, selectedSpaceImageToUpload)">Upload</v-btn>
                            </v-col>
                        </v-row>
                        <v-row no-gutters v-for="(image, index) in selectedSpace.properties.images">
                                <v-col class="pa-0" cols="9">
                                    <v-text-field dense hide-details outlined class="pa-2 pr-0" filled readonly v-model="selectedSpace.properties.images[index]" label="Image"></v-text-field>
                                </v-col>
                                <v-col cols="3">
                                    <v-btn class="mt-2 ml-2" color="red lighten-2" fab small @click="deleteSpaceImage(selectedSpace.properties.images[index], index)"><v-icon>mdi-delete-outline</v-icon></v-btn>
                                </v-col>
                        </v-row>
                        
                         <!-- <span v-for="(item, index) in selectedSpace.properties.images" >
                            <v-file-input dense v-if="index > 0" v-model="selectedSpace.properties.images[index]" accept="image/*" label="Additional Image" hint="Smaller file sizes such as PNG files are ideal, 320px X 320px or 320px X 640px or less in size" persistent-hint></v-file-input>
                         </span> -->
                         <v-divider ></v-divider>
                        <v-card-text>
                             <v-btn small color="red" width="100%" @click="deleteSelectedObject()">
                                 <v-icon>mdi-delete</v-icon>
                                 Delete
                             </v-btn>
                         </v-card-text>
                    </div>

                   </v-card>

               </div>
           </v-col>
       </v-row>
     </v-card>
  </div>
</template>

<script>

import BaseMitLoading from '../../base/components/BaseMitLoading.vue';

import MitMapService from '../services/MitMapService.js';
import MitSpacesService from '../services/MitSpacesService.js';
import MitSpacesSettingsService from '../services/MitSpacesSettingsService.js';
import MitQueryParamService from '../services/MitQueryParamService.js';


export default {
  name: 'MitSpacesMap',
  components: {
      BaseMitLoading
  },
  props: {
      buildingMitId:{
          default:null,
          type:String
      },
      editMode:{
          default:false,
          type:Boolean
      }
  },
  data: function() {
    return {
        loading:true,
        dialogImages:false,
        drawing:false,
        saveDialog:false,
        saveResults:{},
        objectsModel:null,
        spacesList:[],
        spacesModel: {},
        doorsModel: null,
        windowsModel: null,
        structuresModel: null,
        info:{
            levels:[],
            spaceTypes:[],
            spaceUses:[],
            orgs:[],
            floorDict:{}
        },
        showMenuObjects:true,
        existingObjectMitIdsList:{},
        editNameBeforeChanges:'',
        saveObjects:{
            created:[],
            modified:[],
            deleted:[]
        },
        floors:[],
        selectedFloor:0,
        selectedType:null,
        selectedOrg:'COMP SCI & AI LAB',
        selectedSpace:null,
        selectedSpaceImageToUpload:null,
        selectedSpaceImageToUploadLoading:false,
        palletObjectSelected:null,
        palletObjects:[
                    {
                        id:'PRINTER',
                        width:10,
                        height:10,
                        imagePath:'/assets/objects/PRINTER.png',
                        icon:'mdi-printer',
                        name:'Printer'
                    },
                    {
                        id:'PHONEBOOTH',
                        width:15,
                        height:15,
                        imagePath:'/assets/objects/PHONEBOOTH.png',
                        icon:'mdi-card-account-phone',
                        name:'Phonebooth'
                    },
                    {
                        id:'HELPDESK',
                        width:15,
                        height:15,
                        imagePath:'/assets/objects/HELPDESK.png',
                        icon:'mdi-account-wrench',
                        name:'Help Desk'
                    },
                    {
                        id:'AASTATION',
                        width:15,
                        height:15,
                        imagePath:'/assets/objects/AASTATION.png',
                        icon:'mdi-account-group',
                        name:'AA Station'
                    },
                    {
                        id:'CARDREADER',
                        width:5,
                        height:5,
                        imagePath:'/assets/objects/CARDREADER.png',
                        icon:'mdi-card-account-details',
                        name:'Card Reader'
                    }

                ],
        svg:null,
        size:{
            w:1000,
            h:800
        },
        zoom:null,
        search:null,
        mapSpaceSelected:'',
        colorCodes:{
            BACKGROUND:'#DDC7A8',
            GREY:'#838382',
            'CORRIDOR':'#DDC7A8',
            'STAIRWAY':'#838382',
            'ELEVATOR':'#838382'
        },
        mapService:null,
        mitQueryParamService: new MitQueryParamService(),
        settingsService: new MitSpacesSettingsService()
    }
  },
  watch: {
      //Watch for this parameter change. We are using this as the building to grab but also not ideally
      //using it as an event trigger refresh
    'buildingMitId' (to, from) {
        this.init();
    }
  },
  mounted() {
      //Create the map service before anything else since it is a dependency.
      //It needs to be in mounted since this is when the html is ensured to be rendered, since the map service
      //needs to hook into the svg so it can render things.
      this.getObjectDefinitions()
      .then( (data)=> {
          this.mapService = new MitMapService("#mit-svg", this.palletObjects, this.selectedSpaceChanged, null, this.editedObject);
          this.init();
      })

  },
  methods : {
      init(){
          this.mapService.clearMap();//not necessary but makes the UI look a bit nicer when clearing out and rebuilding
          this.getSpacesList();
          this.getBuildingInfo();
          this.getBuildingData()
              .then( (data)=> {
                  this.doorsModel = data.doorsModel;
                  this.windowsModel = data.windowsModel;
                  this.structuresModel = data.structuresModel
                  this.spacesModel = data.spacesModel;
                  this.objectsModel = data.objectsModel;

                  this.initMap();
              })
              .catch( (error)=> {
                  console.log('An error occurred', error);
              });
      },
      initMap(){
          this.floors.splice(0, this.floors.length);
          for(let x = 0; x < this.info.levels.length; x++){
             this.floors.push({name:'Floor '+this.info.levels[x], val:parseInt(this.info.levels[x])});
          }

          let defaultFloor = this.mitQueryParamService.get('l');
          let defaultSelectedSpace = this.mitQueryParamService.get('s');

          if(defaultFloor){
              this.selectedFloor = parseInt(defaultFloor);
          }
          else{
              if(this.floors.length > 3){
                if(this.buildingMitId == 45){
                    this.selectedFloor = this.floors[7].val;
                     //Also special case for this building, we need to add CSAIL to the floors we occupy
                    this.floors[5].name += ' (CSAIL)';
                    this.floors[6].name += ' (CSAIL)';
                    this.floors[7].name += ' (CSAIL)';
                }
                else if (this.buildingMitId == 32){
                    this.selectedFloor = this.floors[2].val;
                }
                  
              }
          }

          this.mapService.setEditMode(true);
          this.mapService.setHighlightMouseOver(true);
          this.mapService.enableZoom("#zoom_in","#zoom_out","#zoom_reset");

          this.drawMap();
          this.mapService.select(defaultSelectedSpace);
      },
      getObjectDefinitions(){
          return this.settingsService.getObjectDefinitions(true)
              .then((data) => {
                  this.palletObjects = data.definitions;
              });
      },
      getSpacesList(){
          MitSpacesService.getSpacesList(this.buildingMitId)
              .then( (data)=> {
                  this.spacesList = data.spaces;
              })
              .catch( (error)=> {
                  console.log('An error occurred', error);
              })
      },
      getBuildingInfo(){
          MitSpacesService.getBuildingStats(this.buildingMitId)
              .then( (data)=> {
                  this.info.levels = data.stats.levels;
                  this.info.spaceTypes = data.stats.useType;
                  this.info.spaceUse = data.stats.useCategory;
                  this.info.orgs = data.stats.orgs;
                  this.info.floorDict = data.floors;

                  if(this.buildingMitId == 45){
                    this.selectedOrg = 'SCHWARZMAN COLLEGE OF COMPUTING';
                  }
                  else if (this.buildingMitId == 32){
                    this.selectedOrg = 'COMP SCI & AI LAB';
                  }
              })
              .catch( (error)=> {
                  console.log('An error occurred', error);
              });

      },
      getBuildingData(geojsonTypes, structureTypes){
          geojsonTypes = geojsonTypes || 'space,door,object';
          structureTypes = structureTypes || 'window,floor';

          return new Promise ((resolve, reject) => {
              this.loading = true;

              let requests = [];

              requests.push(MitSpacesService.getBuildingGeoJson(this.buildingMitId, {types:geojsonTypes}));

              //Sometimes we don't need to ge the structures.
              //This is heavy so try to minimize the times we request this.
              if(structureTypes.length > 0){
                  requests.push(MitSpacesService.getBuildingCoordinates(this.buildingMitId, {types:structureTypes}));
              }

              Promise.all(requests).then((values) => {
                  let mapModelStruct = {};

                  if(values[1]){
                      mapModelStruct = values[1];
                  }

                 let mapModelGeo = this.mapService.convertGeoJSONtoMapModel(values[0]);

                 this.loading = false;
                 resolve({
                     doorsModel: mapModelGeo.door,
                     windowsModel: mapModelStruct.window,
                     structuresModel: mapModelStruct.floor,
                     spacesModel: mapModelGeo.space,
                     objectsModel: mapModelGeo.object
                 });
              })
              .catch( (error)=> {
                 console.log('An error occurred', error);
                 this.loading = false;
                 reject(error);
             });

          });
      },
      saveBuildingData(saveModel){
           return new Promise ((resolve, reject) => {
              let spacesSaveList = saveModel.created.concat(saveModel.modified);
              spacesSaveList = MitSpacesService.convertGeoJSONListtoSpaceModel(spacesSaveList);
              let spacesDeleteList = MitSpacesService.convertGeoJSONListtoSpaceModel(saveModel.deleted);

              let requestPromises = [];
              //CREATE and UPDATE
              if(spacesSaveList.length > 0){
                  requestPromises.push(MitSpacesService.saveSpaces(spacesSaveList));
              }
              //DELETE
              if(spacesDeleteList.length > 0){
                  requestPromises.push(MitSpacesService.deleteSpaces(spacesDeleteList));
              }

              Promise.allSettled(requestPromises).then((promiseResults) => {

                  this.saveResults = {
                      success:true,
                      total:0,
                      successNum:0,
                      failedNum:0,
                      failedMessage:null
                  }

                  for(let x = 0; x < promiseResults.length; x++){
                      if (promiseResults[x].status !== 'fulfilled') {
                          console.log('Error SAVING - message:', promiseResults[x].reason);
                          this.saveResults.failedMessage = 'An error occurred during the save, see logs for details.';
                      }
                      else{
                          this.saveResults.total += promiseResults[x].value.total;
                          this.saveResults.successNum += promiseResults[x].value.numSuccess;
                          this.saveResults.failedNum += promiseResults[x].value.numFailed;
                      }
                  }

                  if(this.saveResults.total != this.saveResults.successNum){
                      this.saveResults.success = false;
                      this.saveResults.failedMessage = 'An error occurred during the save, see logs for details.';
                      reject(this.saveResults);
                  }
                  else{
                      resolve(this.saveResults);
                  }

              })
              .catch((error) => {
                    console.log('Unexpected Error SAVING - message:', promiseResults[x].reason);
                    this.saveResults.success = false;
                    this.saveResults.failedMessage = 'An error occurred during the save, see logs for details.';
                    reject(this.saveResults);
                    
              });
          });

      },
      changeSize(amount){
          this.mapService.changeSizeSelectedObject(amount);
      },
      rotate(angle){
          this.mapService.rotateSelectedObject(angle);
      },
      startDrawing(){
          this.loading = true;
          MitSpacesService.getExistingBuildingObjectMitIds('32')
              .then( (existingObjectMitIdsList)=> {
                  this.drawing = true;
                  this.mapService.setEditModelAllowModify(true, existingObjectMitIdsList);
                  this.existingObjectMitIdsList = existingObjectMitIdsList;
                  this.loading = false;
              })
              .catch( (error)=> {
                  console.log('An error occurred', error);
                  this.loading = false;
              })
      },
      deleteSelectedObject(){
          this.mapService.deleteSelectedObject();
          this.closeProperties()
      },
      editedObject(eventType, space){

        switch(eventType){
            case this.mapService.EDIT_OBJECT_TYPE.CREATED:
                this.objectsModel[space.properties.level].features.push(space);
                //Add the created object to a list to send to server upon save
                this.saveObjects.created.push(space);
                //also add this object to the list of used names
                this.existingObjectMitIdsList[space.properties.mitId] = 1;
            break;
            case this.mapService.EDIT_OBJECT_TYPE.MODIFIED:
                if(space.properties.id && this.saveObjects.modified.indexOf(space) === -1)
                    this.saveObjects.modified.push(space);
            break;
            case this.mapService.EDIT_OBJECT_TYPE.DELETED:

                //check to make sure the user didn't add a new object and then remove it
                if(this.saveObjects.created.indexOf(space) > -1){
                    //if this is the case just remove it.
                    this.saveObjects.created.splice(this.saveObjects.created.indexOf(space), 1);
                }
                //check to make sure the user didn't modify an existing space and then delete it
                else if(this.saveObjects.modified.indexOf(space) > -1){
                    //if this is the case just remove it.
                    this.saveObjects.modified.splice(this.saveObjects.modified.indexOf(space), 1);
                    this.saveObjects.deleted.push(space);
                }
                //The user just straight up deleted something that existed before.
                else {
                    this.saveObjects.deleted.push(space);
                }

                //also delete this object from list of used names.
                delete this.existingObjectMitIdsList[space.properties.mitId];
            break;
        }

    },
    editedSelectedSpaceProperties(event){
        //Add validation here
        //valid characters and not in existingObjectMitIdsList
        this.editedObject(this.mapService.EDIT_OBJECT_TYPE.MODIFIED, this.selectedSpace);
    },
    editNameEnter(event){
        //capture the intial name in case we need to revert
        //Also need to remove it from the used names list, if changed successfully.
        this.editNameBeforeChanges = this.selectedSpace.properties.name;
    },
    editNameLeave(event){
        //Special case for property since I am generating the mit id based off the name to give some
        //useful context as to what the object is.
        //We need to do some uniqueness checks and update the name that was changed.
        if(this.selectedSpace.properties.spaceType === 'object'){
            if(this.existingObjectMitIdsList.hasOwnProperty(this.selectedSpace.properties.mitId)){
                delete this.existingObjectMitIdsList[this.selectedSpace.properties.mitId];
            }
            this.existingObjectMitIdsList[this.selectedSpace.properties.mitId] = 1;
            //update the mitIds based on name
            let objInto = this.mapService.renameObjectInfo(this.existingObjectMitIdsList, this.editNameBeforeChanges, this.selectedSpace.properties.name, this.selectedSpace.properties.mitId, this.selectedSpace.properties.mitIdShort);

            this.selectedSpace.properties.name = objInto.name;
            this.selectedSpace.properties.mitId = objInto.mitId;
            this.selectedSpace.properties.mitIdShort = objInto.mitIdShort;
        }

    },
    changeFloor(){
        this.mitQueryParamService.add('l',this.selectedFloor);
        this.drawMap();
    },
    selectedSpaceChanged(space){
        if(space){
            this.selectedSpace = space;
            this.mitQueryParamService.add('s',space.properties.mitId);
            this.mitQueryParamService.add('l',space.properties.level);
            this.mitQueryParamService.add('b',space.properties.mitBuildingId);
        }
        else{
            this.selectedSpace = null;
            this.mitQueryParamService.remove(['s']);
        }
    },
    closeProperties(){
        this.mapService.deselect();
    },
    autocompleteSearch(item, queryText, itemText) {
      const textMitIdShort = item.mitIdShort.toLowerCase();
      const textUse = item.useType.toLowerCase()
      const textName = item.name.toLowerCase()
      const searchText = queryText.toLowerCase()

      return textMitIdShort.indexOf(searchText) > -1  || textUse.indexOf(searchText) > -1  || textName.indexOf(searchText) > -1
    },
    autocompleteChanged(item){
        if(item && item.mitId){
            this.mapSpaceSelected = item.mitId;
            this.selectedFloor = parseInt(item.level);
        }
        else{
            this.mapSpaceSelected = '';
        }

        this.drawMap();
    },
    palletObjectChanged(){
        if(this.palletObjectSelected){
            this.mapService.changeCreateObject(this.palletObjectFindById(this.palletObjectSelected));
        }
        else{
            this.mapService.changeCreateObject(null);
        }

    },
    palletObjectFindById(id){
        for(let x = 0; x < this.palletObjects.length; x++){
            if(this.palletObjects[x].id === this.palletObjectSelected)
                return this.palletObjects[x];
        }
    },
    clearSaveObjects(){
        this.saveObjects = {
            created:[],
            modified:[],
            deleted:[]
        };
    },
    closeSaveDialog(){
        this.saveDialog = false;

        //refresh the data that can be modified only.
        //no need to refresh windows and structures as they can't be changed, so save the time
        this.getBuildingData('space,door,object', '')
            .then( (data)=> {
                this.doorsModel = data.doorsModel;
                this.spacesModel = data.spacesModel;
                this.objectsModel = data.objectsModel;

                this.drawMap();
            })
            .catch( (error)=> {
                console.log('An error occurred', error);
            });
    },
    save(){
        this.drawing = false;
        this.palletObjectSelected = null;
        this.mapService.changeCreateObject(null);
        this.mapService.setEditModelAllowModify(false);

        this.loading = true;

        //Can i do upsert and then just update the object, spaces, doors models only?
        this.saveBuildingData(this.saveObjects)
            .then( (data)=> {
                this.loading = false;
                this.clearSaveObjects();
                //show dialog of saved items.
                this.saveDialog = true;
            })
            .catch( (error)=> {
                this.loading = false;
                this.clearSaveObjects();//Risk of losing data here, if they could try again, but I think its safer to clear and not have duplicate risk.
                //show dialog of saved items.
                this.saveDialog = true;
                console.log('An error occurred', error);
            });
    },
    cancel(){
        this.clearSaveObjects();
        this.drawing = false;
        this.palletObjectSelected = null;
        this.mapService.changeCreateObject(null);
        this.mapService.setEditModelAllowModify(false);

        this.getBuildingData('space,door,object', '')
            .then( (data)=> {
                this.doorsModel = data.doorsModel;
                this.spacesModel = data.spacesModel;
                this.objectsModel = data.objectsModel;

                this.drawMap();
            })
            .catch( (error)=> {
                console.log('An error occurred', error);
            });
    },
    drawMap(){
        this.mapService.createMap(this.spacesModel, this.objectsModel, this.doorsModel, this.windowsModel, this.structuresModel, this.info.floorDict, this.size.w, this.size.h, this.selectedFloor, this.selectedType, this.mapSpaceSelected, this.selectedOrg );
    },
    uploadSpaceImage(spaceId){
        this.selectedSpaceImageToUploadLoading = true;
        
        //make call to API
        
        //if error
        this.selectedSpaceImageToUploadLoading = false;

          MitSpacesService.uploadSpaceImage(spaceId, this.selectedSpaceImageToUpload, this.selectedSpace.properties.images.length)
              .then( (data)=> {
                  //if successful
                  this.selectedSpace.properties.images.push(data.filename);
                  //Set flag that we modified this space/object
                  this.editedSelectedSpaceProperties();
                  this.selectedSpaceImageToUploadLoading = false;
                  this.selectedSpaceImageToUpload = null;
              })
              .catch( (error)=> {
                  this.selectedSpaceImageToUploadLoading = false;
                  console.log('An error occurred', error);
              });
      },
      deleteSpaceImage(imageName, index){
        //call to API
          MitSpacesService.deleteSpaceImage(imageName)
              .then( (data)=> {
                    //Set flag that we modified this space/object
                    this.editedSelectedSpaceProperties();
                  this.selectedSpace.properties.images.splice(index, 1);
              })
              .catch( (error)=> {
                  console.log('An error occurred', error);
              })
      },
  }
}
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
  .scrollable {
   overflow-y: scroll;
   overflow-x: scroll;
  }
  .toolbar-drawing-left {
      position: absolute;
      top: 80px;
      left: 0px;
      width: 210px;
      height: 100px;
      // border: 3px solid #73AD21;
  }
  .toolbar-drawing-center {
      position: absolute;
      top: 80px;
      left: calc(50% - (100px));
      width: 200px;
      height: 100px;
      // border: 3px solid #73AD21;
  }
  .toolbar-drawing-right {
      position: absolute;
      top: 80px;
      right: 0;
      width: 300px;
      height: 100px;
      // border: 3px solid #73AD21;
  }
  // .mit-map {
  //     margin-top: -60px;
  //     margin-left: -80px;
  // }
</style>
